import { render, staticRenderFns } from "./sysNotice-add-or-update.vue?vue&type=template&id=433e8619&"
import script from "./sysNotice-add-or-update.vue?vue&type=script&lang=js&"
export * from "./sysNotice-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports